import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AppConfig } from '~/core/models/appconfig';
const FILE = 'assets/config.json';
const LOCAL_FILE = 'assets/setlocal.json';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: AppConfig = new AppConfig();
  private http: HttpClient;

  constructor(private httpHandler: HttpBackend) {
    this.http = new HttpClient(this.httpHandler);
  }

  public async init(): Promise<boolean> {
    try {
      const config$ = this.http.get<AppConfig>(FILE);
      let localConfig: Partial<AppConfig> | null = null;
      try {
        const local$ = this.http.get<Partial<AppConfig>>(LOCAL_FILE);
        localConfig = await lastValueFrom(local$);
      } catch (e) {
      }
      const configData = await lastValueFrom(config$);
      // Merge local config if available
      this.config = { ...configData, ...(localConfig || {}) };
      return true;
    } catch (error) {
      console.error('Error loading config:', error);
      throw error;
    }
  }

  public getConfig(key?: string | string[]): any {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.config;
    }

    const path = Array.isArray(key) ? key : key.split('.');
    return path.reduce((acc: any, current: string) => acc?.[current], this.config);
  }
}